import React from "react";
import PropTypes from "prop-types";
//Material imports
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
// Limitless imports
import CodeCollector from "@limitless/portal/components/code-collector/CodeCollector";
import LoginButton from "../buttons/login-button/LoginButton";
import Anchor from "./AnchorLink";
import { useMFASetupContext } from "../../hooks/mfa-setup/MFASetupContext";
import { useSignInContext } from "@limitless/expert/hooks/sign-in/SignInContext";
import { getParseMfaPhoneNumber } from "@limitless/portal/utils";
import { useHistory } from "react-router-dom";
import { MFA_CTX_SETUP, MFA_CTX_LOGIN } from "@limitless/portal";
import { useAppConfig } from "@limitless/common/hooks";
import { SignInForm, useExpertProfileContext } from "../../../expert";
const CODE_NOT_RECEIVED_TXT = "Didn't get the code?";
const MFAVerify = ({
  t,
  successCB,
  mfaType,
  mfaVerificationFrozen,
  mfaState
}) => {
  const {
    maxLength,
    clearCodes,
    verifyMFAState,
    verifyButtonHandler,
    resendButtonHandler,
    updateCodeCollector,
    mfaCtx
  } = useMFASetupContext();
  const {
    signIn
  } = useSignInContext();
  const color = React.useMemo(() => verifyMFAState.verifyFailed || verifyMFAState.errTxt ? "error" : "textSecondary", [verifyMFAState.verifyFailed, verifyMFAState.errTxt]);
  const history = useHistory();
  const {
    getContactUsUrl,
    config: {
      dialCodes
    }
  } = useAppConfig();
  const disableVerificationBtn = React.useMemo(() => !verifyMFAState.btnVisible || verifyMFAState.freezeVerification || mfaVerificationFrozen, [mfaVerificationFrozen, verifyMFAState.freezeVerification, verifyMFAState.btnVisible]);
  const mfaVerificationDisabled = React.useMemo(() => verifyMFAState.freezeVerification || mfaVerificationFrozen, [mfaVerificationFrozen, verifyMFAState.freezeVerification]);
  const showErrMsg = React.useMemo(() => !verifyMFAState.loading && (verifyMFAState.errTxt || verifyMFAState.verifyFailed), [verifyMFAState]);
  const changePhoneNumberClick = () => {
    const navigationPath = "/contact-us";
    const url = getContactUsUrl(navigationPath);
    if (url === navigationPath) {
      history.push(url);
    } else {
      window.open(url, "_blank");
    }
  };
  const handleResendCallback = () => {
    // No operation
  };
  const parsePhoneNumber = getParseMfaPhoneNumber(mfaState.phoneNumber, dialCodes);
  return /*#__PURE__*/React.createElement(SignInForm, null, ({
    onFormSubmit
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CodeCollector, {
    clearAll: clearCodes,
    max: maxLength,
    onUpdate: updateCodeCollector
  }), /*#__PURE__*/React.createElement(Box, {
    minHeight: 38
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8
  }, showErrMsg && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    style: {
      marginBottom: 20,
      marginTop: -10
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    color: color,
    variant: "subtitle1"
  }, t(verifyMFAState.errTxt))), /*#__PURE__*/React.createElement(LoginButton, {
    disabled: disableVerificationBtn,
    loading: verifyMFAState.loading,
    id: "mfaCodeVerifyButton",
    onClick: async () => await verifyButtonHandler({
      type: mfaType,
      primaryContactNumber: parsePhoneNumber,
      mfaState
    }, successCB)
  }, t("Verify"))), !mfaVerificationDisabled && /*#__PURE__*/React.createElement(Grid, {
    style: {
      marginTop: 20,
      textAlign: "center",
      maxWidth: 325
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, mfaCtx === MFA_CTX_LOGIN && /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    color: "textPrimary"
  }, t(CODE_NOT_RECEIVED_TXT), /*#__PURE__*/React.createElement(Anchor, {
    onClick: () => onFormSubmit(null),
    t: t,
    text: t("Resend")
  })), mfaCtx === MFA_CTX_SETUP && /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, verifyMFAState.checkDeviceForMFACode ? t("Please check your device for new code") : /*#__PURE__*/React.createElement(React.Fragment, null, t(CODE_NOT_RECEIVED_TXT), /*#__PURE__*/React.createElement(Anchor, {
    onClick: resendButtonHandler({
      type: mfaType
    }),
    t: t,
    text: t("Resend")
  })))))));
};
export default MFAVerify;
MFAVerify.propTypes = {
  t: PropTypes.func.isRequired,
  successCB: PropTypes.func,
  setToPhoneScreen: PropTypes.func,
  mfaVerificationFrozen: PropTypes.bool,
  mfaType: PropTypes.string.isRequired,
  mfaState: PropTypes.object
};